<div class="area-form-input">

    <div class="area-form-input__header">

        <!-- type icon -->
        <div class="area-form-input__type-icon-container">
            <div class="area-form-input__type-icon" [ngClass]="getAreaIconTypeClass()">
                <span class="tag"></span>
            </div>
        </div>

        <!-- input  -->
        <input type="text" class="area-form-input__input" [formControl]="$any(control)"
               placeholder="{{'map.area-name' | translate}}"
            clearOnFocus [newAreaNamePlaceHolder]="newAreaNamePlaceHolder" (onFocusChanged)="onFocusChanged()"
            maxlength="50" />

    </div>

    <!-- clear button -->
    <span *ngIf="control.value" class="area-form-input__clear-icon" (click)="onClear()"></span>

</div>
